const MEETING_TYPE = ['Accompagnement ECE', 'Accompagnement FO', 'Accompagnement BO', 'Compagnonnage BO', 'Compagnonnage FO'];

export default MEETING_TYPE;
